import { render, staticRenderFns } from "./HelpList.vue?vue&type=template&id=325e947c&"
import script from "./HelpList.vue?vue&type=script&lang=js&"
export * from "./HelpList.vue?vue&type=script&lang=js&"
import style0 from "./HelpList.vue?vue&type=style&index=0&id=325e947c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports